<div class="app-section">
    <div class="container-fluid p-0" [ngClass]="hasPadding ? 'has-padding' : 'no-padding'">
        <div class="section" [ngClass]="{'sectionCard' : sectionCard ,'TypeB': TypeB ,'NoBack':NoBack}">
            <div>
                <h2 class="section__title" [class]="'section__title ' + titleClass" *ngIf="sectionTitle"
                    [ngClass]="{'alignSwitchAR': switchLangService.currentLang=='ar', 'alignSwitchEN':switchLangService.currentLang=='en'}">
                    <span>{{sectionTitle}}</span>
                    <span class="sperator">:</span>
                </h2>
            </div>
            <!-- <div class="divider" *ngIf="sectionTitle"></div> -->
            <div fxLayout="row" fxLayoutAlign="center top" fxLayout.xs="column" class="section__container"
                *ngIf="showContainer"
                [ngClass]="{'alignSwitchAR': switchLangService.currentLang=='ar', 'alignSwitchEN':switchLangService.currentLang=='en'}">
                <div fxFlex="100">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>